import React from 'react';

export default function Footer() {
  return (
    <footer className="w-full border-t border-gray-200 bg-white">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex flex-col lg:flex-row items-center lg:items-start justify-between gap-8">

          {/* Author */}
          <div className="text-center sm:text-left">
            <h3 className="text-lg font-bold text-gray-900">
              Rama Bhadra Rao Maddu
            </h3>
            <p className="text-gray-600 text-sm">Asst. Professor &amp; HOD, BCA</p>
            <p className="text-gray-500 text-sm">Independent Researcher and Educator</p>
            <p className="text-gray-400 text-xs mt-0.5">Building Quantum Computing Visualizations</p>
          </div>

          {/* Event / institutional highlight */}
          <div className="flex flex-col items-center gap-3">
            <div className="text-gray-500 text-xs font-semibold tracking-wide uppercase">
              Presented at
            </div>
            <div className="flex items-center gap-4">
              <div className="bg-gray-50 rounded-xl px-3 py-2 flex items-center gap-2 border border-gray-200">
                <img src="/swrnandhra-logo.png" alt="Swarnandhra College logo" className="w-8 h-8 object-contain" />
                <span className="text-gray-800 text-xs font-bold leading-tight max-w-[110px]">
                  Swarnandhra College of Engineering &amp; Technology
                </span>
              </div>
              <div className="bg-gray-50 rounded-xl px-3 py-2 flex items-center gap-2 border border-gray-200">
                <span className="w-8 h-8 rounded-full bg-gradient-to-br from-purple-500 via-pink-500 to-amber-400 flex items-center justify-center text-base flex-shrink-0">
                  💡
                </span>
                <span className="text-gray-800 text-xs font-bold leading-tight max-w-[90px]">
                  AICTE IDEA Lab &mdash; Grand Inauguration
                </span>
              </div>
            </div>
            <div className="text-gray-400 text-xs">September 11, 2026</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
